import base from "./base"
const en = {
    ...base
}
export default en
